import { Button, CircularProgress, Fade, fade, Grow, lighten, makeStyles, Typography } from '@material-ui/core';
import { useContext, useEffect, useState } from 'react';
import LimitedBackdrop from '../../../components/UI/LimitedBackdrop';
import { separations } from '../../../constants/StyleConstants';
import { ClaimContext } from '../../../contexts/ClaimContext';
import { transitionTimeout } from './ClaimWizard';

const useStyles = makeStyles(theme => ({
  ...separations,
  root: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
  },
  claimsContainer: {
    position: 'relative',
    display: 'flex',
    flexWrap: 'wrap',
    margin: '1em',
    height: '100%',
  },
  claimWrapper: {
    width: '30%',
    flexGrow: 1,
    justifyContent: 'space-between',
    textAlign: 'center',
    margin: '1em',
  },
  claimButton: {
    position: 'relative',
    width: '100%',
    height: '100%',
    borderRadius: 5,
    padding: theme.spacing(2),
    backgroundColor: lighten(theme.palette.primary.main, 0.6),
    color: 'black',
    transition: 'all .2s ease-in-out',
    overflow: 'hidden',
    '&:hover': {
      backgroundColor: fade(theme.palette.primary.main, 0.7),
      color: 'white',
      transform: 'scale(1.05)',
    },
  },
}));

const NewClaimSelection = ({ claimsAvailables }) => {
  const classes = useStyles();
  const [transIn, setTransIn] = useState(true);
  const { alreadyOpen, setAlreadyOpen, setStepElements, stepForward, setSelectedClaimId } = useContext(ClaimContext);

  const handleStep = id => {
    setSelectedClaimId(id);
    stepForward();
  };

  useEffect(() => {
    const step = {
      stepNumber: 0,
      transition: {
        enter: () => {
          setTransIn(true);
          setSelectedClaimId(null);
        },
        exit: () => setTransIn(false),
      },
    };

    setStepElements(step.stepNumber, step);
  }, []);

  return (
    <Grow in={transIn} appear={alreadyOpen} timeout={transitionTimeout} onExit={() => setAlreadyOpen(true)} unmountOnExit>
      <div className={classes.root}>
        <Typography className={classes.bottomSeparation}>Seleccione el tipo de reclamo que desea iniciar</Typography>
        <div className={classes.claimsContainer}>
          <LimitedBackdrop open={claimsAvailables.isEmpty()}>
            <CircularProgress color="primary" />
          </LimitedBackdrop>
          <Fade in={!claimsAvailables.isEmpty()}>
            <>
              {claimsAvailables.map(claim => (
                <div className={classes.claimWrapper}>
                  <Button
                    key={claim.id}
                    className={classes.claimButton}
                    variant="contained"
                    color="primary"
                    onClick={() => handleStep(claim.id)}>
                    {claim.text}
                  </Button>
                </div>
              ))}
            </>
          </Fade>
        </div>
      </div>
    </Grow>
  );
};

export default NewClaimSelection;
